import * as React from 'react';

import SignFieldSignature16 from './SignFieldSignature16';

export const signFieldSignature16 = () => <SignFieldSignature16 />;

export default {
    title: 'Icon/Fill/SignFieldSignature16',
    component: SignFieldSignature16,
    parameters: {
        notes: "`import SignFieldSignature16 from 'box-ui-elements/es/icon/fill/SignFieldSignature16';`",
    },
};
